import { render } from "./IconButtonLayout.vue?vue&type=template&id=9ab6fa7c&scoped=true"
import script from "./IconButtonLayout.vue?vue&type=script&lang=js"
export * from "./IconButtonLayout.vue?vue&type=script&lang=js"

import "./IconButtonLayout.vue?vue&type=style&index=0&id=9ab6fa7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9ab6fa7c"

export default script